import { Component, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { UserService } from 'app/shared/services/user.service';
import { ListType } from 'app/types';

@AutoUnsubscribe()
@Component({
  selector: 'manage-list-component',
  templateUrl: './manage-list.component.html',
  styleUrls: ['./manage-list.component.scss'],
})
export class ManageListComponent implements OnInit {
  public data: any;
  public columnsSettings: Array<any>;
  public isLoading: boolean;
  public isError: boolean;
  public emptyDataSettings: any;
  public subscriptions: Array<any>;

  constructor(
    public httpService: HttpService,
    public gridService: GridService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public modalsService: ModalsService,
    public ga: GoogleAnalyticsService,
    public userService: UserService
  ) {
    this.data = [];
    this.columnsSettings = [
      { key: 'id', label: 'LIST_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'LIST_NAME', filterType: 'INPUT', width: 200 },
      {
        key: 'type',
        label: 'LIST_TYPE',
        filterType: 'SELECT',
        parseFunction: this.gridService.parseListType,
        parseTooltipFunction: this.gridService.parseListType,
      },
      { key: 'list_items_counter', label: 'NUMBER_OF_ITEMS' },
      { key: 'created', label: 'CREATED_AT' },
    ];
    this.isLoading = false;
    this.isError = false;
    this.emptyDataSettings = {
      title: 'WELCOME_TO_CEDATO',
      info: 'MANAGE_LISTS_NO_DATA',
      buttonText: 'CREATE_NEW',
      buttonLink: '/list/new',
    };
    this.subscriptions = [];
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.initialize();
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.initialize();
        } else if (response.type === 'DELETE_LIST_CONFIRM') {
          this.deleteList(response.data);
        }
      })
    );
    this.sharedService.setPageTitle('MANAGE_LISTS');
  }

  initialize() {
    this.isLoading = true;
    this.subscriptions.push(
      this.httpService.post('restriction_lists/getAllLists', { playerId: 'all' }).subscribe(
        (response: any) => {
          const data: Array<any> = _.cloneDeep(response.lists);
          data.forEach((item: any) => {
            item.type = parseInt(item.type);
            item.$$link = item.id;
            item.$$actions = [
              { type: 'EDIT', link: true },
              { type: 'DOWNLOAD', link: false },
              { type: 'DELETE', link: false },
            ];
          });
          this.data = data;
          this.isLoading = false;
        },
        (error: any) => {
          // Display the error message
          this.isLoading = false;
          this.isError = true;
        }
      )
    );
  }

  openCreateAListModal() {
    this.modalsService.showModal({ component: 'new_list', title: this.dictionaryService.get('NEW_LIST') });
  }

  onDownloadClick(item: any) {
    this.subscriptions.push(
      this.httpService.post('restriction_lists/getRestrictionListFile/' + item.id, {}).subscribe(
        (response: any) => {
          const blob = new Blob([response.data], { type: 'text/csv; charset=utf-8' });
          saveAs(blob, this.dictionaryService.get('LIST') + item.id + '.txt');
        },
        (error: any) => {
          this.modalsService.showModal({
            component: 'new-list-component',
            title: this.dictionaryService.get('AN_ERROR_HAS_OCCURRED'),
          });
        }
      )
    );
  }

  onDeleteClick(item: any) {
    this.modalsService.showModal({
      component: 'delete-list-confirm',
      title: this.dictionaryService.get('DELETE_LIST'),
      data: item,
    });
  }

  deleteList(item: any) {
    this.isLoading = true;
    const endpoint = item.type == ListType.SCHAIN
      ? 'restriction_lists/deleteSchainList'
      : 'restriction_lists/deleteList';
    this.subscriptions.push(
      this.httpService.post(endpoint, { id: item.id, type: item.type }).subscribe(
        (response: any) => {
          this.initialize();
          this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_DELETED_SUCCESSFULLY'), 'success');
        },
        (error: any) => {
          // Display the error message
          this.isLoading = false;
          this.isError = true;
        }
      )
    );
  }
}
